// src/utils/push.ts
import { post } from './request';


// VAPID public key, you need to replace this with your own key
const applicationServerPublicKey = 'BBYCxwATP2vVgw7mMPHJfT6bZrJP2iUV7OP_oxHzEcNFenrX66D8G34CdEmVULNg4WJXfjkeyT0AT9LwavpN8M4=';

function urlB64ToUint8Array(base64String: string) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

function arrayBufferToBase64(buffer: ArrayBuffer) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
}

async function sendSubscriptionToServer(subscription: PushSubscription) {
    // Your server needs to implement this endpoint
    const payload = {
        notificationEndPoint: subscription.endpoint,
        publicKey: arrayBufferToBase64(subscription.getKey('p256dh')!),
        auth: arrayBufferToBase64(subscription.getKey('auth')!)
    };
    return post('/subscribe', payload);
}

async function removeSubscriptionFromServer(endpoint: string) {
    // Your server needs to implement this endpoint
    return post('/unsubscribe', { notificationEndPoint: endpoint });
}

export async function subscribeUserToPush() {
    try {
        const registration = await navigator.serviceWorker.ready;
        
        const existingSubscription = await registration.pushManager.getSubscription();
        
        if (existingSubscription) {
            console.log('[Push] Found existing subscription. Unsubscribing to re-subscribe for backend update.');
            await existingSubscription.unsubscribe();
            console.log('[Push] Old subscription removed.');
        }

        console.log('[Push] Creating new subscription...');
        const applicationServerKey = urlB64ToUint8Array(applicationServerPublicKey);
        const newSubscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: applicationServerKey,
        });
        
        console.log('[Push] New subscription successful, sending to server...');
        await sendSubscriptionToServer(newSubscription);
        console.log('[Push] New subscription sent to server.');
    } catch (error) {
        console.error('Failed to subscribe the user: ', error);
    }
}

export async function unsubscribeUserFromPush() {
    try {
        const registration = await navigator.serviceWorker.ready;
        const subscription = await registration.pushManager.getSubscription();

        if (subscription) {
            await subscription.unsubscribe();
            console.log('User is unsubscribed.');
            await removeSubscriptionFromServer(subscription.endpoint);
            console.log('Subscription removal sent to server.');
        }
    } catch (error) {
        console.error('Failed to unsubscribe the user: ', error);
    }
}
